import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Layout, Title } from 'common/components/layout';
import { unsubscribe } from 'redux/customer/actions';

const Unsubscribe = () => {
  const [customer, setCustomer] = useState(null);

  const location = useLocation();
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.setting.data);

  useEffect(() => {
    const { emailId, customerId, customerEmailId } = queryString.parse(
      location.search
    );
    const payload = {
      emailId,
      customerEmailId
    };
    const successFunction = (data) => {
      setCustomer(data);
    };
    dispatch(unsubscribe(customerId, payload, successFunction));
  }, [dispatch, location.search]);

  if (!settings) {
    return (
      <Layout title="Unsubscribe" loading>
        <Title>Unsubscribe</Title>
      </Layout>
    );
  }
  return (
    <Layout title="Unsubscribe">
      <Title>Unsubscribe</Title>
      {!customer && <div>Loading...</div>}
      {customer && <Customer customer={customer} />}
    </Layout>
  );
};

export default Unsubscribe;

const Customer = (props) => {
  const { customer } = props;
  const { emails } = customer;
  if (emails.length === 1) {
    return (
      <>
        <p>{emails[0].email} has been unsubscribed.</p>
      </>
    );
  }
  return (
    <>
      The following emails have been unsubscribed:
      <ul>
        {emails.map((emailObj) => (
          <li key={emailObj.email}>{emailObj.email}</li>
        ))}
      </ul>
    </>
  );
};
